import { put, takeLatest } from "redux-saga/effects";
import { requestFeeDetailsReportsList } from "services/acclgl/reports/feeDetailsReports";
import {
  fetchFeeDetailsReportsListRequest,
  fetchFeeDetailsReportsListSuccess,
  fetchFeeDetailsReportsListFailure,

  fetchTransportDetailsReportsListRequest,
  fetchTransportDetailsReportsListSuccess,
  fetchTransportDetailsReportsListFailure,

  fetchSupplementaryDetailsReportsListRequest,
  fetchSupplementaryDetailsReportsListSuccess,
  fetchSupplementaryDetailsReportsListFailure,
} from "redux/reducers/acclgl/reports/feeDetailsReports";
export function* watchFeeDetailsReportsSaga() {
  yield takeLatest(
    fetchFeeDetailsReportsListRequest,
    fetchFeeDetailsReportsList
  );
  yield takeLatest(
    fetchTransportDetailsReportsListRequest,
    fetchTransportDetailsReportsList
  );
  yield takeLatest(
    fetchSupplementaryDetailsReportsListRequest,
    fetchSupplementaryDetailsReportsList
  );
}

function* fetchFeeDetailsReportsList({ payload }) {
  try {
    const response = yield requestFeeDetailsReportsList(payload);
    yield put(fetchFeeDetailsReportsListSuccess(response));
  } catch (error) {
    yield put(
      fetchFeeDetailsReportsListFailure("Failed to get list of reports")
    );
  }
}

function* fetchTransportDetailsReportsList({ payload }) {
  try {
    const response = yield requestFeeDetailsReportsList(payload);
    yield put(fetchTransportDetailsReportsListSuccess(response));
  } catch (error) {
    yield put(
      fetchTransportDetailsReportsListFailure("Failed to get list of reports")
    );
  }
}

function* fetchSupplementaryDetailsReportsList({ payload }) {
  try {
    const response = yield requestFeeDetailsReportsList(payload);
    yield put(fetchSupplementaryDetailsReportsListSuccess(response));
  } catch (error) {
    yield put(
      fetchSupplementaryDetailsReportsListFailure("Failed to get list of reports")
    );
  }
}
